import React, { PureComponent } from "react";
import { CardIcon } from "./Icons";

import { accessConfig, initialData } from "./services/access-config";

import "./Welcome.css";

export default class Welcome extends PureComponent {
  accessConfigData = initialData;
  render() {
    const { startNewInscription, school } = this.props;
    return (
      <div className="cm-welcome">
        <div
          className="cm-welcome--header"
          onClick={accessConfig(this.accessConfigData, this.props.navToConfig)}
        >
          {/* <img
            src="/images/logo-clubmed.svg"
            alt="Club Med"
            className="cm-welcome--clubmed"
          /> */}
        </div>
        <div className="cm-welcome--inscription">
          <img
            src="/images/logo-esf.svg"
            alt="ESF"
            className="cm-welcome--esf"
          />

          <div className="cm-welcome--welcome">Bienvenue à</div>
          <div className="cm-welcome--esf-name">L'{school}</div>

          <div className="cm-welcome--buttons">
            <button
              onClick={startNewInscription("fr")}
              className="cm-welcome--new-inscription"
            >
              <div className="cm-welcome--flag">
                <img src="/images/flag-fr.svg" alt="français" />
              </div>
              <div className="cm-welcome--icon">
                <CardIcon className="cm-welcome--cardicon" />
              </div>
              <div className="cm-welcome--text">
                <div className="cm-welcome--text__bold">
                  Nouvelle inscription
                </div>
                <div>{school}</div>
              </div>
            </button>
            <button
              onClick={startNewInscription("en")}
              className="cm-welcome--new-inscription"
            >
              <div className="cm-welcome--flag">
                <img src="/images/flag-gb.svg" alt="english" />
              </div>
              <div className="cm-welcome--icon">
                <CardIcon className="cm-welcome--cardicon" />
              </div>
              <div className="cm-welcome--text">
                <div className="cm-welcome--text__bold">New inscription</div>
                <div>{school}</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Welcome.js